import { render, staticRenderFns } from "./Tablepm.vue?vue&type=template&id=355ec2b4&scoped=true&"
import script from "./Tablepm.vue?vue&type=script&lang=js&"
export * from "./Tablepm.vue?vue&type=script&lang=js&"
import style0 from "./Tablepm.vue?vue&type=style&index=0&id=355ec2b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355ec2b4",
  null
  
)

export default component.exports